<rask-fieldset-toggle label="Produktionsstatus"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-multi-selector
        label="Produktionsstatus"
        [items]="options"
        bindLabel="text"
        bindValue="value"
        class="w-100"
        [formControlName]="name"
        [selected]="form.value.produktionsstatus">
    </rask-multi-selector>
</rask-fieldset-toggle>